import {
  DownOutlined,
  FileTextOutlined,
  OrderedListOutlined,
  PushpinOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { Dropdown, Menu, Space } from 'antd'

import { Links } from 'components/routes/paths'

import { renderFormatMessage } from 'helpers/intl'
import { addQueryString } from 'helpers/url'

import { useTenantTranslation } from 'hooks/translation/useTenantTranslation'
import { Tenant } from 'models/tenant'
import { theme } from 'theme'

const menuStyle = {
  backgroundColor: theme.colors.white,
  border: `1px solid ${theme.colors.frenchGray}`,
  borderRadius: '5px',
}

interface TenantsActionsMenuProps {
  tenant: Tenant
}

const TenantsActionsMenu = ({ tenant }: TenantsActionsMenuProps) => {
  const { overviewLinkText, locationLinkText, accessPlanText, waitlistText } = useTenantTranslation()

  const renderLink = (title: string, link: string) => (
    <a href={link} target="_blank" rel="noreferrer" aria-label={title}>
      {title}
    </a>
  )

  const menuItems = [
    {
      title: overviewLinkText,
      link: addQueryString(Links.tenant({ tenantId: tenant.id }), { defaultTab: 'overview' }),
      icon: <SettingOutlined style={{ fontSize: '20px', color: theme.colors.darkGray, marginRight: 0 }} />,
    },
    {
      title: locationLinkText,
      link: addQueryString(Links.tenant({ tenantId: tenant.id }), { defaultTab: 'location' }),
      icon: <PushpinOutlined style={{ fontSize: '20px', color: theme.colors.darkGray, marginRight: 0 }} />,
    },
    {
      title: accessPlanText,
      link: addQueryString(Links.tenant({ tenantId: tenant.id }), { defaultTab: 'accessPlan' }),
      icon: <FileTextOutlined style={{ fontSize: '20px', color: theme.colors.darkGray, marginRight: 0 }} />,
    },
    {
      title: waitlistText,
      link: addQueryString(Links.tenant({ tenantId: tenant.id }), { defaultTab: 'waitlist' }),
      icon: <OrderedListOutlined style={{ fontSize: '20px', color: theme.colors.darkGray, marginRight: 0 }} />,
    },
  ]
  const menu = (
    <Menu style={menuStyle}>
      {menuItems.map((item) => (
        <Menu.Item key={item.title} icon={item?.icon}>
          {renderLink(item.title, item.link)}
        </Menu.Item>
      ))}
    </Menu>
  )

  return (
    <Dropdown overlay={menu} overlayClassName="custom-dropdown" aria-haspopup="true" aria-controls="actions-menu">
      <span onClick={(e) => e.preventDefault()} role="button" tabIndex={0} aria-label="More actions">
        <Space>
          <span style={{ color: theme.colors.softBlack, textTransform: 'uppercase' }}>
            {renderFormatMessage('dashboard.text.more', 'More')}
          </span>
          <DownOutlined style={{ color: theme.colors.softBlack }} />
        </Space>
      </span>
    </Dropdown>
  )
}

export default TenantsActionsMenu
